export const lowercase = (value) => {
	if (!/(?=.*[a-z])/.test(value)) {
		return 'Must contain a lowercase letter';
	}
};
